import * as React from 'react';
import type { ChangeHook } from 'react-router';
import { IndexRoute, Route } from 'react-router';

import { Route as CourseraRoute } from '@coursera/react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import { ProgramHomePageTypes } from 'bundles/enterprise-legacy-learner-home/constants/ProgramHomeConstants';
import RouteNames from 'bundles/enterprise-legacy-learner-home/constants/RouteNames';
import OrgLandingPage from 'bundles/org-landing/pages/OrgLandingPageContent';
import OrgLandingApp from 'bundles/org-landing/pages/OrgLandingRoot';

const NotFound = loadOnRoute(() => import('bundles/phoenix/components/NotFound'));

const scrollToTopOnNavigate: ChangeHook = (prevState, nextState) => {
  if (nextState.location.action !== 'PUSH') {
    // history navigation
    return;
  }

  if (nextState.location.pathname !== prevState.location.pathname) {
    // always on path navigation
    window.scrollTo(0, 0);
  }
};

const routes = (
  <CourseraRoute
    onChange={scrollToTopOnNavigate}
    handle={{
      tracking: {
        data: (params) => ({
          page: { segment: 'enterprise' },
          enterprise: {
            organizationSlug: params?.orgSlug,
            ...(params?.programSlug ? { programSlug: params.programSlug } : {}),
          },
        }),
      },
    }}
  >
    <CourseraRoute
      name={RouteNames.ENTERPRISE_LEARNER_LANDING_ROOT}
      path="programs/landing/:orgSlug"
      component={OrgLandingApp}
      handle={{
        tracking: {
          data: () => ({
            page: { type: ProgramHomePageTypes.HOME },
          }),
        },
      }}
    >
      <IndexRoute name={RouteNames.ENTERPRISE_LEARNER_LANDING} component={OrgLandingPage} />
    </CourseraRoute>
    <Route path="*" getComponent={NotFound} />
  </CourseraRoute>
);

export default routes;
